var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.buscarAtasParaAprovacao.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacao", $$v);
      },
      expression: "form.filters.formacao"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data de Realização",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataRealizacao", $$v);
      },
      expression: "form.filters.dataRealizacao"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": _vm.form.lists.situacoes,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-submit-button'), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.list.headers,
      "items": _vm.list.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.acoes`,
      fn: function (_ref) {
        var item = _ref.item;
        return [item.situacao !== 'Concluída' ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Aprovar Ata",
            "icon": "mdi-calendar-check",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.detalharAtaParaAvaliacao(item);
            }
          }
        }) : _vm._e(), item.situacao === 'Concluída' ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Baixar Ata",
            "icon": "mdi-download",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.baixarAta(item);
            }
          }
        }) : _vm._e()];
      }
    }], null, true)
  })], 1), _c('AprovarAtaDialog', {
    attrs: {
      "visible": _vm.dialogAprovarAta.visible,
      "content": _vm.dialogAprovarAta.content,
      "edit": _vm.dialogAprovarAta.edit
    },
    on: {
      "onClose": _vm.onCloseDialog
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }